// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Product from './Product';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Product);
